export enum eButtonColorTheme {
    Green = '',
    Black = 'black',
    White = 'white',
    DarkContrast = 'dark-contrast',
    LightContrast = 'light-contrast',
}